import { Grid, Pagination } from '@mui/material';
import { t } from 'i18next';
import * as React from 'react';

export default function TablePageControl({ length, setLength, page, setPage, totalPage, total }) {

    const [pageList, setPageList] = React.useState();

    React.useEffect(() => {
        if (totalPage) {
            let tempPageList = [];
            for (let index = 0; index < totalPage; index++) {
                tempPageList.push({ label: index + 1, value: index + 1 })
            }
            setPageList(tempPageList);
        }

    }, [totalPage])

    const handleChangePage = (event, value) => {
        setPage(value);
    };
    return (
        <React.Fragment>
            <Grid container spacing={2} style={{ marginTop: "auto" }}>
                <Grid item lg={3} sm={12}>
                    <span className='text-bold'>{total || 0}</span> {t('record(s)')}
                </Grid>
                <Grid item lg={9} sm={12} display={'flex'} alignItems={'center'} sx={{ justifyContent: { lg: 'flex-end', md: 'flex-end' } }}>
                    <div className='d-flex align-items-center'>
                        {t('Rows per page')}
                        <select
                            className=""
                            style={{ border: '0px', padding: 5, cursor: 'pointer', marginRight: 15, marginLeft: 10 }}
                            value={length}
                            onChange={(e) => setLength(e.target.value)}
                        >
                            {[10, 20, 30, 40, 50].map(pageSize => (
                                <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                </option>
                            ))}
                        </select>
                    </div>
                    <Pagination
                        count={totalPage || 1}
                        defaultPage={5}
                        siblingCount={0}
                        page={Number(page)}
                        hideNextButton={false}
                        hidePrevButton={false}
                        onChange={handleChangePage}
                        sx={{
                            // Disabled pagination items
                            '& .MuiPaginationItem-root.Mui-selected': {
                                backgroundColor: '#F9F9F9',
                                color: '#594A4E',
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
